<template>
  <basic-container>
    <div class="search">
      <el-form ref="routeQueryForm" :model="query" :inline="true" size="mini">
        <el-form-item label="订单号">
          <el-input
            @keydown.enter.native.prevent="querySearch"
            placeholder="请输入订单号"
            v-model="query.orderNo"
            clearable
          />
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="dateArray"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            end-placeholder="结束日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="站点" prop="stationId">
          <yd-common-selector
            v-model="query.stationId"
            placeholder="请输入关键字查找线路名称"
            :options="stationNameList"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="searchChange">
            筛选
          </el-button>
          <el-button type="danger" icon="el-icon-delete" :loading="loading" @click="searchReset">
            清空
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <yd-table
        :data="orderData"
        :loading="loading"
        :pagination="pagination"
        @onChange="onTableChange"
      >
        <el-table-column label="订单编号" prop="orderId" align="center" width="300">
          <template slot-scope="scope">
            <el-tooltip placement="right" effect="dark" trigger="hover">
              <el-button type="text" @click="openMap(scope.row)">{{ scope.row.orderNo }}</el-button>
              <template v-slot:content>
                <span style="cursor: pointer" @click="copyOrderNo(scope.row.orderNo)">复制</span>
              </template>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="订单类型" prop="type" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.type ? scope.row.type : '接单' }}
          </template>
        </el-table-column>
        <el-table-column label="订单距离（公里）" prop="distance" align="center" width="170">
          <template slot-scope="scope">
            {{ scope.row.distance || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="订单价格" prop="price" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.price / 100 }}
          </template>
        </el-table-column>
        <el-table-column label="订单出发时间" prop="tripTime" align="center" width="170">
          <template slot-scope="scope">
            {{ scope.row.tripTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="订单派单时间" prop="beginTime" align="center" width="170">
          <template slot-scope="scope">
            {{ scope.row.beginTime || '-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="送达乘客时间" prop="lineName" align="center"  width="120"/> -->
        <el-table-column label="是否派单成功" prop="scheduleSuc" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.scheduleSuc === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="派单成功时间" prop="sucTime" align="center" width="170">
          <template slot-scope="scope">
            {{ scope.row.sucTime || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="派单次数" prop="num" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.num || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="接单司机" prop="driverPhone" align="center" width="120">
          <template slot-scope="scope">
            {{ scope.row.driverPhone || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="是否拼单" prop="mergeType" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.mergeType && scope.row.mergeType === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
      </yd-table>
    </div>

    <div v-if="visible">
      <el-dialog title="位置信息" :visible.sync="visible" width="1200px">
        <MapInfo :data="mapData" :centerPoint="centerPoint" />
      </el-dialog>
    </div>
  </basic-container>
</template>

<script>
  import { queryAllFstation } from '@/api/transport/routeset'
  import { postOrderCount, postOrderPage, postVehicleInfo } from '@/api/dispatch/index'
  import MapInfo from './map'
  import { copyText } from '@/util'
  export default {
    components: {
      MapInfo
    },
    data() {
      return {
        visible: false,
        tableData: [],
        loading: false,
        query: {},
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0
        },
        dateArray: [],
        orderData: [],
        mapData: {},
        centerPoint: [],
        stationNameList: []
      }
    },
    watch: {},
    mounted() {
      this.getAllStation()
    },
    methods: {
      /* openMap(v) {
		this.mapData=v
		this.visible = true
      },
	  */
      async copyOrderNo(v) {
        if (!v) {
          return
        }
        console.log(v)
        await copyText(v)
        this.$message.success('复制成功')
      },
      async openMap(v) {
        if (!v.orderPoint) {
          this.$message.error('订单数据有误')
          return
        }
        const res = await postVehicleInfo({
          orderNo: v.orderNo
        })
        if (res.code === 0) {
          const icon = {
            type: 'image',
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
            size: [25, 30],
            anchor: 'bottom-center'
          }
          const data = res.data
          this.centerPoint = [v.orderPoint.lon, v.orderPoint.lat]
          // this.driverList=this.mergeArraysByProperty(this.data.nearVehicleVos,res.data,'driverId')
          data.forEach((item, index) => {
            item.zooms = [1, 20]
            item.icon = icon
            item.zIndex = 100
            item.position = [item.point.lon.toFixed(6), item.point.lat.toFixed(6)]
            item.text = {
              content:
                item.jobDriver === 1 ? `接单司机 ${item.carNum}` : `司机${index + 1}${item.carNum}`,
              direction: 'right',
              offset: [0, -5],
              style: {
                fontSize: 14,
                fontWeight: 'normal',
                fold: true,
                padding: '2, 5',
                backgroundColor: item.jobDriver === 1 ? '#FF7624' : '#EAF4FD',
                fillColor: item.jobDriver === 1 ? '#fff' : '#333'
              }
            }
          })

          const orderPoint = [
            {
              position: [v.orderPoint.lon.toFixed(6), v.orderPoint.lat.toFixed(6)],
              zooms: [10, 20],
              zIndex: 100,
              icon,
              text: {
                content: '用户下单位置',
                direction: 'right',
                offset: [0, -5],
                style: {
                  fontSize: 14,
                  fontWeight: 'normal',
                  fillColor: '#fff',
                  fold: true,
                  padding: '2, 5',
                  backgroundColor: '#07c160'
                }
              }
            }
          ]

          this.mapData = [...data, ...orderPoint]
          this.visible = true
        }
      },

      // mergeArraysByProperty(arr1, arr2, prop) {
      //     // 创建一个映射表，用于快速查找
      //     const map = new Map();

      //     // 首先将第一个数组的元素存入映射表
      //     arr1.forEach(item => {
      //         map.set(item[prop], { ...item });
      //     });

      //     // 然后处理第二个数组，合并到映射表中
      //     arr2.forEach(item => {
      //         const key = item[prop];
      //         if (map.has(key)) {
      //             // 如果存在相同属性值，合并对象
      //             map.set(key, { ...map.get(key), ...item });
      //         } else {
      //             // 如果不存在，直接添加
      //             map.set(key, { ...item });
      //         }
      //     });
      //     // 将映射表转换回数组并返回
      //     return Array.from(map.values());
      // },

      tabChange(tab, event) {
        this.searchReset()
      },
      initPage() {
        if (this.dateArray.length > 0) {
          this.query.beginTime = this.dateArray[0]
          this.query.endTime = this.dateArray[1]
        }
        const params = {
          ...this.pagination,
          ...this.query
        }
        this.getOrderList(params)
      },
      searchChange() {
        this.pagination.pageNo = 1
        this.initPage()
      },
      searchReset() {
        this.query = {}
        this.dateArray = []
        this.pagination.pageNo = 1
        this.initPage()
      },
      // 获取所有的站点
      getAllStation() {
        queryAllFstation().then((res) => {
          if (!Array.isArray(res.data)) {
            return
          }
          res.data.forEach((it) => {
            it.label = it.stationName
            it.value = it.id
          })
          this.stationNameList = res.data
        })
      },

      onTableChange({ current, pageSize }) {
        this.pagination.current = current
        this.pagination.size = pageSize
        this.pagination.page = current
        this.pagination.pageSize = pageSize
        this.initPage()
      },

      getOrderList(params) {
        this.loading = true
        postOrderPage(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.orderData = data
              this.getOrderCount(params)
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      getOrderCount(params) {
        postOrderCount(params)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.pagination.total = data
            }
          })
          .finally(() => {})
      }
    }
  }
</script>

<style>
  .add-button {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .route-pagination {
    margin-left: 65%;
  }
</style>
